import type { MaybeRefOrGetter } from 'vue';

import { useQuery } from '@vue/apollo-composable';
import { useDocumentVisibility } from '@vueuse/core';
import { computed, toValue } from 'vue';

import { GetLocationAttentionDocument, type GetLocationAttentionQuery } from '@shared/api/graphql/gql/graphql';

export type LocationAttentionRow = GetLocationAttentionQuery['locationAttention'][number];

/**
 * Сводка плашки раз в минуту; ошибка — плашка без чисел по другим локациям. Скрытая вкладка не
 * опрашивает сервер: при возврате на неё активные запросы перечитывает data-refresh runtime.
 * Плашка монтируется заново на каждой странице, поэтому монтирование берёт кэш: свежесть держат
 * опрос и перечитывание по имени после мутаций платежей.
 */
export function useLocationAttention(enabled: MaybeRefOrGetter<boolean>) {
  const visibility = useDocumentVisibility();
  const { result, refetch } = useQuery(GetLocationAttentionDocument, null, () => ({
    enabled: toValue(enabled),
    pollInterval: visibility.value === 'visible' ? 60_000 : 0,
    fetchPolicy: 'cache-first',
  }));
  const byLocation = computed(
    () => new Map((result.value?.locationAttention ?? []).map((row) => [row.location_id, row] as const)),
  );

  return { byLocation, refetch };
}

export type UseLocationAttentionReturn = ReturnType<typeof useLocationAttention>;
